import {PriceFormState} from './PriceForm-State'
import {errorsList, errorsPresent, mergeServerValidationErrors} from '../../../helpers/ErrorHelper'
import {endOfURL} from '../../../helpers/UrlHelper'
import {isObject} from "../../../helpers/DataHelper";

export default function priceFormReducer(state = PriceFormState, action) {

    let {data} = {...state};
    let {validationErrors, name, value, price, mode} = action;
    switch (action.type) {

        case 'ON-PRICE-FORM-CHANGE':
            data.payload[name] = value;
            buildErrors();
            return {...state, data};

        case 'ON-PRICE-FORM-MODE-CHANGE':
            data.mode = mode;
            buildErrors();
            return {...state, data};

        case 'SET-PRICE-DATA-FOR-UPDATE':
            data.payload = {
                price: price.price,
                currency: price.currency,
                site_type: price.site_type,
            };
            buildErrors();
            return {...state, data};

        case 'SET-DEFAULT-PRICE-FORM':
            data = {
                payload: {
                    price: ``,
                    site_type: ``,
                    currency: ``
                },

                errors: [],
                errorsPresent: false,
                submitted: false,
                dispatchAPI: false,
                mode: endOfURL(),
                message: ``
            };
            buildErrors();
            return {...state, data};

        case 'CANCEL-PRICE-FORM-DISPATCH':
            data.dispatchAPI = false;
            data.submitted = false;
            buildErrors();
            return {...state, data};

        case 'ON-PRICE-FORM-SUBMIT':
            data.submitted = true;
            buildErrors();
            if (!data.errorsPresent) data.dispatchAPI = true;
            return {...state, data};

        case 'PRICE-FORM-SERVER-VALIDATION-ERRORS':
            validationErrors && isObject(validationErrors) &&
            Object.keys(validationErrors).map(key =>
                data.errors[key] = [{message: ` - ${validationErrors[key][0]}`.slice(0, -1)}]
            );
            data.dispatchAPI = false;
            return {...state, data};

        default:
            return state
    }

    function buildErrors() {
        data.errors = errorsList(errors)
        data.errorsPresent = errorsPresent(errors)
    }

    function errors(field) {
        let {payload, submitted, validationErrors} = data;
        let errors = {};
        Object.keys(payload).map(key => errors[key] = []);

        if (submitted) {
            if (field === `price`) {
                if (!_(field)) newError(field, 0, `This is required field`)
            }
            if (field === `site_type`) {
                if (!_(field)) newError(field, 0, `This is required field`)
            }
            if (field === `currency`) {
                if (!_(field)) newError(field, 0, `This is required field`)
            }
        }

        errors = mergeServerValidationErrors(errors, validationErrors)

        return field ? errors[field] : errors

        function newError(field, step, message) {
            errors && errors[field].push({step, message})
        }

        function _(field) {
            return data.payload[field]
        }
    }
}